import React from "react";
import {FormControl} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
    formControl: {
        width: '100%',
    },
    error_label: {
        color: 'red',
        fontSize: '0.75em',
        marginTop: '5px',
        fontFamily: 'roboto',
    },

    list_box: {
        overflowY: 'scroll',         
        border: '1px solid darkgray', 
        padding: '10px 0px',
        borderRadius: 6
    },

    list_item: {
        "&:hover": {
          backgroundColor: "lightgray",
        },
        padding: '5px 20px'
    },
    list_item_close: {
        width: 15,
        heiht: 15,
        opacity: 0.5,
        cursor: 'pointer'
    },
    list_item_text: {
        //
    },
    list_item_table: {
        width: '100%',
        cellSpacing: 0,
        cellPadding: 0,
    },
    list_item_table_close: {
        textAlign: 'right'
    },
    empty: {
        padding: '5px 20px',
        opacity: 0.5
    },
}));

export default function List({name, value, options, customPlaceholder, valueField = 'id', titleField = 'title', error, disabled, height = 250, onOptionDelete, ...rest}) {
    const classes = useStyles();

    return (<FormControl variant="outlined" className={classes.formControl} error={!!error} disabled={disabled}>
            <div className={classes.list_box} style={{height}}>
                {!options?.length && <div className={classes.empty}>{customPlaceholder}</div>}
                {!!options?.length && options.map((option, index) => (
                    <div key={index} className={classes.list_item} value={option[valueField]}>
                        <table className={classes.list_item_table}>
                            <tr>
                                <td>
                                    <div className={classes.list_item_text}>
                                        {option}
                                    </div>
                                </td>
                                <td className={classes.list_item_table_close}>
                                     <img
                                        className={classes.list_item_close}
                                        src="/images/close.png" 
                                        onClick={() => onOptionDelete(option)}
                                    />
                                </td>
                            </tr>
                        </table>
                    </div>
                ))}
            </div>
        </FormControl>)

    {/*<div className={classes.error_label} style={{display: error ? 'block' : 'none'}}>
        {error}
    </div>*/}
};
